import React from "react";

import { css } from "@emotion/css";

import Logo from "../img/svg/footer-logo.svg";
import IGIcon from "../img/svg/ig-icon.svg";
import FBIcon from "../img/svg/fb-icon.svg";
import TTIcon from "../img/svg/tt-icon.svg";
import SubstackIcon from "../img/svg/substack-icon.svg";
import LinkedInIcon from "../img/svg/linkedin-icon.svg";
import YouTubeIcon from "../img/svg/youtube-icon.svg";
import { desktop, laptop, tablet } from "../styles/breakpoints";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

export const Social = ({ isMobile = false }) => {
  const { t } = useI18n();
  return (
    <div className={`${style.social} ${isMobile ? "mobile" : "desktop"}`}>
      <a href="https://www.tiktok.com/@zilouet?_t=ZN-8zmTxICI9Ru&_r=1" target="_blank" rel="noopener noreferrer">
        <img src={TTIcon} alt={t("social_alt_tiktok")} />
      </a>
      <a href="https://www.instagram.com/zilouetofficial?igsh=dmI0aGltN241bDZw" target="_blank" rel="noopener noreferrer">
        <img src={IGIcon} alt={t("social_alt_instagram")} />
      </a>
      <a href="https://www.facebook.com/zilouet" target="_blank" rel="noopener noreferrer">
        <img src={FBIcon} alt={t("social_alt_facebook")} />
      </a>
      <a href="https://www.youtube.com/@zilouet" target="_blank" rel="noopener noreferrer">
        <img src={YouTubeIcon} alt={t("social_alt_youtube")} />
      </a>
      <a href="https://zilouet.substack.com" target="_blank" rel="noopener noreferrer">
        <img src={SubstackIcon} alt={t("social_alt_substack")} />
      </a>
      <a href="https://www.linkedin.com/company/zilouet" target="_blank" rel="noopener noreferrer">
        <img src={LinkedInIcon} alt={t("social_alt_linkedin")} />
      </a>
    </div>
  );
};

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer style={{ position: "relative" }}>
      <div className={style.container}>
        <div className="menu">
          <div className="left">
            <img src={Logo} alt={t("header_logo_alt")} />
            <p className="tagline">{t("footer_desc")}</p>
            <div className="content">
              <Social />
            </div>
          </div>

          <div className="right">
            <div className="content">
              <Link to="/">{t("header_home")}</Link>
              <Link to="/retailers">{t("header_retailers")}</Link>
              <Link to="/blog">{t("header_blog")}</Link>
              {/* TEMPORARILY DISABLED: "How it works" link. Re-enable by uncommenting. */}
              {/* <Link to="/technology">{t("header_how")}</Link> */}
              <Link to="/about">{t("header_about")}</Link>
              <Link to="/contact">{t("header_contact")}</Link>
            </div>
          </div>
        </div>

        <Social isMobile={true} />

        <div className="copy">
          <div className="left">
            <Link>©2024 Zilouet. All rights reserved</Link>
          </div>
          <div className="right">
            <Link to="/privacy-policy">{t("header_privacy")}</Link>
            <Link to="/terms-conditions">{t("header_terms")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

const style = {
  social: css({
    height: 300,
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    gap: 16,
    position: "relative",

    img: {
      width: 68,
      height: 68,
    },

    hr: {
      height: 0,
      width: "100%",
      position: "absolute",
      bottom: 30,
      left: 0,
      borderTop: "1px solid #F5E1E2",
    },

    [desktop]: {
      gap: 32,

      img: {
        width: 90,
        height: 90,
      },
    },
    [laptop]: {
      height: 200,
      gap: 32,

      img: {
        width: 64,
        height: 64,
      },
    },
    [tablet]: {
      height: 140,
      gap: 18,

      img: {
        width: 50,
        height: 50,
      },
    },
  }),
  container: css({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "stretch",
    maxWidth: 1300,
    margin: "auto",
    padding: 40,
    paddingTop: 175,
    paddingBottom: 45,
    overflow: "hidden",

    ".desktop": {
      display: "flex !important",
    },
    ".mobile": {
      display: "none !important",
    },
    a: {
      color: "#000",
      fontFamily: "Syne",
      fontSize: 23.955,
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "normal",
    },
    ".tagline": {
      color: "#000",
      textAlign: "center",
      width: "100%",
      margin: "58px auto 0",
      maxWidth: 460,
      fontFamily: "Inter",
      fontSize: 23.76,
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
      letterSpacing: 0.36,
    },
    h2: {
      color: "#A5AEC3",
      fontFamily: "Yapari Trial Regular",
      fontSize: 52,
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "normal",
      marginBottom: 52,
    },
    ".menu": {
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 16,
      position: "relative",

      hr: {
        height: 0,
        width: "100%",
        position: "absolute",
        top: 60,
        left: 0,
        borderTop: "1px solid #E2E9FA",
      },
      ".left": {
        textAlign: "left",

        ".content": {
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",
          alignContent: "center",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: 44,

          p: {
            color: "#000",
            textAlign: "center",
            fontFamily: "Inter",
            fontSize: 18,
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal",
            letterSpacing: 0.36,
            maxWidth: 354,
          },
        },
      },
      ".right": {
        position: "relative",
        textAlign: "right",
        marginTop: 150,

        ".content": {
          textAlign: "right",
          gap: 26,
          columnGap: 72,
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gridTemplateRows: "1fr 1fr 1fr",
          justifyItems: "start",

          a: {
            flex: "0 0 21%",
          },
        },
      },
    },

    ".copy": {
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      justifyContent: "space-between",
      alignContent: "flex-start",
      alignItems: "flex-start",
      gap: 16,

      ".left": {
        display: "flex",
        gap: 120,
      },
      ".right": {
        display: "flex",
        gap: 60,
      },
      a: {
        color: "#000",
        fontFamily: "Inter",
        fontSize: 13,
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "normal",
        letterSpacing: 0.13,
      },
    },
    [desktop]: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "stretch",
      maxWidth: 700,
      margin: "auto",
      padding: 40,
      paddingTop: 195,
      paddingBottom: 30,
      ".desktop": {
        display: "none !important",
      },
      ".mobile": {
        display: "flex !important",
      },

      a: {
        fontSize: 38,
      },
      ".menu": {
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        alignContent: "center",
        justifyContent: "space-between",
        alignItems: "stretch",
        gap: 107,
        position: "relative",

        ".left": {
          textAlign: "center",

          img: {
            maxWidth: 640,
          },

          ".content": {
            marginTop: 107,
            p: {
              fontSize: 28,
              letterSpacing: 0.56,
              maxWidth: "100%",
              textAlign: "left",
            },
          },
        },
        '.right': {
          marginTop: 0,
        },
      },

      ".copy": {
        display: "flex",
        flexDirection: "column-reverse",
        flexWrap: "nowrap",
        alignContent: "space-around",
        justifyContent: "center",
        alignItems: "center",
        gap: 32,
        margin: "auto",

        ".left": {
          gap: 60,
        },
        ".right": {
          gap: 60,
        },
        a: {
          fontSize: 24,
          letterSpacing: 0.24,
        },
      },
    },
    [laptop]: {
      maxWidth: 500,
      margin: "auto",
      padding: 40,
      paddingTop: 155,
      paddingBottom: 50,

      a: {
        fontSize: 24,
      },
      ".menu": {
        gap: 64,

        ".left": {
          img: {
            maxWidth: 480,
          },

          ".content": {
            marginTop: 64,
            p: {
              fontSize: 18,
              letterSpacing: 0.36,
            },
          },
        },
      },

      ".copy": {
        gap: 20,

        ".left": {
          gap: 30,
        },
        ".right": {
          gap: 30,
        },
        a: {
          fontSize: 16,
          letterSpacing: 0.16,
        },
      },
    },
    [tablet]: {
      maxWidth: 289,
      margin: "auto",
      padding: 40,
      paddingTop: 115,
      paddingBottom: 30,

      a: {
        fontSize: 18,
      },
      ".menu": {
        gap: 40,

        ".left": {
          img: {
            maxWidth: 289,
            width: '100%',
          },

          ".content": {
            marginTop: 40,
            p: {
              fontSize: 14,
              letterSpacing: 0.28,
            },
          },
        },
        ".right": {

          ".content": {
            maxWidth: 250,
            columnGap: 61,
            margin: "auto",
          },
        },
      },

      ".copy": {
        gap: 12,

        ".left": {
          gap: 20,
        },
        ".right": {
          gap: 20,
        },
        a: {
          fontSize: 12,
          letterSpacing: 0.12,
        },
      },
    },
  }),
};
